/**
 * 문제집 필터 컴포넌트
 * - 연도, 학년, 학기 필터
 * - 문제집명 검색
 */

import React from 'react';
import { Input, Select, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Option } = Select;

/**
 * 필터 상태 인터페이스
 */
export interface WorkbookFilterState {
  search?: string;
  year?: number;
  grade?: number;
  semester?: number;
}

interface WorkbookFiltersProps {
  onFilter: (filters: WorkbookFilterState) => void;
}

/**
 * WorkbookFilters 컴포넌트
 * 문제집 목록 필터링 UI
 */
export const WorkbookFilters: React.FC<WorkbookFiltersProps> = ({ onFilter }) => {
  const [filters, setFilters] = React.useState<WorkbookFilterState>({});

  /**
   * 필터 변경 처리
   */
  const handleFilterChange = (key: keyof WorkbookFilterState, value: any) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  /**
   * 검색어 변경 처리
   */
  const handleSearch = (value: string) => {
    handleFilterChange('search', value || undefined);
  };

  /**
   * 연도 옵션 생성 (현재 년도 기준 ±5년)
   */
  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear + 1; i >= currentYear - 5; i--) {
      years.push(i);
    }
    return years;
  };

  /**
   * 학년 옵션 (초1~고3 매핑)
   */
  const gradeOptions = [
    { label: '초1', value: 1 },
    { label: '초2', value: 2 },
    { label: '초3', value: 3 },
    { label: '초4', value: 4 },
    { label: '초5', value: 5 },
    { label: '초6', value: 6 },
    { label: '중1', value: 7 },
    { label: '중2', value: 8 },
    { label: '중3', value: 9 },
    { label: '고1', value: 10 },
    { label: '고2', value: 11 },
    { label: '고3', value: 12 },
  ];

  return (
    <Space style={{ marginBottom: 16 }}>
      {/* 검색 */}
      <Search
        placeholder="문제집명 검색"
        allowClear
        onSearch={handleSearch}
        prefix={<SearchOutlined />}
        style={{ width: 250 }}
      />

      {/* 연도 필터 */}
      <Select
        placeholder="연도 선택"
        allowClear
        style={{ width: 120 }}
        onChange={(value) => handleFilterChange('year', value)}
      >
        {getYearOptions().map((year) => (
          <Option key={year} value={year}>
            {year}년
          </Option>
        ))}
      </Select>

      {/* 학년 필터 */}
      <Select
        placeholder="학년 선택"
        allowClear
        style={{ width: 120 }}
        onChange={(value) => handleFilterChange('grade', value)}
      >
        {gradeOptions.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>

      {/* 학기 필터 */}
      <Select
        placeholder="학기 선택"
        allowClear
        style={{ width: 120 }}
        onChange={(value) => handleFilterChange('semester', value)}
      >
        <Option value={1}>1학기</Option>
        <Option value={2}>2학기</Option>
      </Select>
    </Space>
  );
};
